import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c29f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  value: "",
  disabled: ""
}
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  for: "option-control",
  class: "control-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      name: "option-control",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      required: ""
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.placeholder), 1),
      (_ctx.isMultiGroup)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.options, (group, groupKey) => {
            return (_openBlock(), _createElementBlock("optgroup", { key: groupKey }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: key,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_3))
              }), 128))
            ]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.options, (item, key) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: item
            }, _toDisplayString(item), 9, _hoisted_4))
          }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selected]
    ]),
    _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.title), 1),
    _hoisted_6
  ]))
}